/** Small display helpers for the operator console. */

/** integer cents → "$21,000" (no cents shown for whole-dollar amounts). */
export function formatCents(cents: number | null | undefined): string {
  if (cents == null) return '—';
  const dollars = cents / 100;
  return dollars.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: Number.isInteger(dollars) ? 0 : 2,
    maximumFractionDigits: 2,
  });
}

/** "$21,000" (string dollars) → integer cents, or null if blank/invalid. */
export function dollarsToCents(input: string): number | null {
  const cleaned = input.replace(/[^0-9.]/g, '').trim();
  if (!cleaned) return null;
  const value = Number.parseFloat(cleaned);
  if (!Number.isFinite(value) || value < 0) return null;
  return Math.round(value * 100);
}

export function formatMiles(mi: number | null | undefined): string {
  return mi == null ? '—' : `${mi.toLocaleString('en-US')} mi`;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
}

/** "a, b ,c" → ['a','b','c'] (trimmed, de-duped, blanks dropped). */
export function csvToArray(input: string): string[] {
  return [...new Set(input.split(',').map((s) => s.trim()).filter(Boolean))];
}

/** ['a','b'] → "a, b" for display/edit. */
export function arrayToCsv(arr: string[] | null | undefined): string {
  return (arr ?? []).join(', ');
}
